// extracted by mini-css-extract-plugin
export default {"content":"UserConfirmation_content__vfgJR","modal":"UserConfirmation_modal__BA9AE","title":"UserConfirmation_title__jpY+q"};